<div id="body-container">
  <div class="background-blue">
    <div class="breadcrumbs-container container page-banner">
      <h1 style="font-size:22.5px;"><adp-label labelKey="Deductible_Lookup_Header"></adp-label></h1>
    </div>
  </div>
  <div class="deductible-lookup-container">
    <div *ngIf="currentPage === deductibleLookupFlow.lookup" class="container" style="margin-top:50px;margin-bottom:20px;">
      <div><pgh-deductible-lookup-device (formSubmitted)="changeFlow(deductibleLookupFlow.results)"></pgh-deductible-lookup-device></div>
    </div>
    <div *ngIf="currentPage === deductibleLookupFlow.results" class="container" style="margin-top:50px;margin-bottom:20px;">
      <div><pgh-deductible-lookup-results (newLookupClicked)="changeFlow(deductibleLookupFlow.lookup)"></pgh-deductible-lookup-results></div>
    </div>
  </div>
  <div class="deductible-lookup-container">
    <div class="container" style="margin-top:50px;margin-bottom:50px;">
      <div><pgh-deductible-service-fees></pgh-deductible-service-fees></div>
    </div>
  </div>